import { OnBoardingStatus } from "lib/common/types/onBoardingStatus";
import { useCallback, useEffect, useState } from "react";
import { host } from "../../utils/constants";
import checkIfLoggedInOrNot from "../common/helper/login";
import { User } from "../common/types/user";
import myaxios from "../myAxios";

function useGetOnboardStatus() {
  const [data, setData] = useState<OnBoardingStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetchStatus = useCallback(() => {
    myaxios
      .post(host + "/auth/register/onboarding_status")
      .then((data) =>
        setData(data.data.data.onBoardingStatus as OnBoardingStatus),
      )
      .finally(() => setLoading(false));
  }, []);

  const fetchOnboardStatus = useCallback(async () => {
    return myaxios
      .post(host + "/auth/register/onboarding_status")
      .then((data) => data.data.data.onBoardingStatus as OnBoardingStatus);
  }, []);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      setLoading(true);
      const loggedIn = await checkIfLoggedInOrNot();

      if (!isActive) return;

      if (loggedIn) {
        refetchStatus();
      } else {
        setLoading(false);
      }
    };

    void load();

    return () => {
      isActive = false;
    };
  }, [refetchStatus]);

  return { data, loading, error, fetchOnboardStatus, refetchStatus };
}

export default useGetOnboardStatus;
